<template>
  <div style="height:100%" class="text-center">
    <img v-lazy="getLazyImg()" :style="cssVars" :class="imgClass" loading="lazy" :alt="imgAlt" />
  </div>
</template>

<script>
export default {
  props: {
    mainImg: {
      type: String,
      required: true,
    },
    fallbackImg: {
      type: String,
      default: null,
    },
    imgAlt: {
      type: String,
      required: true,
    },
    imgWidth: {
      type: Number,
    },
    imgHeight: {
      type: Number,
    },
    imgClass: {
      type: String,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width': this.imgWidth ? this.imgWidth + 'px' : 'undefined',
        '--height': this.imgHeight ? this.imgHeight + 'px' : 'undefined',
      }
    },
  },
  methods: {
    getLazyImg() {
      let fallback = this.fallbackImg
        ? this.fallbackImg
        : this.getCustomFallback()
      return {
        src: this.mainImg,
        error: fallback,
      }
    },
    getCustomFallback() {
      let words = this.imgAlt.split(' ')
      let cap =
        words.length > 1
          ? words
              .map((x) => x[0].toUpperCase())
              .join('')
              .slice(0, 2)
          : words[0].toUpperCase().slice(0, 2)
      let color = Math.floor(Math.random() * 16777215).toString(16)
      let imgWidth = this.imgWidth ? this.imgWidth : 128;
      let imgHeight = this.imgHeight ? this.imgHeight : 128;
      return `https://dummyimage.com/${imgWidth}x${imgHeight}/${color}/ffffff.jpg&text=${cap}`
    },
  },
}
</script>

<style lang="scss">
img[lazy='loaded'] {
  width: var(--width);
  height: var(--height);
}
img[lazy='loading'] {
  width: 38px !important;
  height: 38px !important;
}
</style>